import { checkIsAgent, checkIsPerformer, checkIsCD } from "shared-auth";
import { HeapCustomEvent, HeapService } from "shared-services";

const PATH_NAME = window.location.pathname;
const VIDEO_ENDPOINT = "/profile/media/video";
const AUDIO_ENDPOINT = "/profile/media/audio";

const profileUpdate = (isProfileRedesign?: boolean) => {
  HeapService.track(
    isProfileRedesign
      ? HeapCustomEvent.ProfileRedesignUpdate
      : HeapCustomEvent.ProfileUpdate
  );
};

const audioClipsPerformerUpdate = (isProfileRedesign?: boolean) => {
  HeapService.track(
    isProfileRedesign
      ? HeapCustomEvent.ProfileRedesignAudioClipsPerformer
      : HeapCustomEvent.AudioClipsPerformer
  );
};

const audioClipsAgentUpdate = (isProfileRedesign?: boolean) => {
  HeapService.track(
    isProfileRedesign
      ? HeapCustomEvent.ProfileRedesignAudioClipsAgent
      : HeapCustomEvent.AudioClipsAgent
  );
};

const videoPerformerUpdate = (isProfileRedesign?: boolean) => {
  HeapService.track(
    isProfileRedesign
      ? HeapCustomEvent.ProfileRedesignVideosPerformer
      : HeapCustomEvent.VideosPerformer
  );
};

const videoAgentUpdate = (isProfileRedesign?: boolean) => {
  HeapService.track(
    isProfileRedesign
      ? HeapCustomEvent.ProfileRedesignVideosAgent
      : HeapCustomEvent.VideosAgent
  );
};

const cdAudioVideoPlayed = (isProfileRedesign?: boolean) => {
  HeapService.track(
    isProfileRedesign
      ? HeapCustomEvent.ProfileRedesignCDAudioVideoPlayed
      : HeapCustomEvent.CDAudioVideoPlayed
  );
};

const agentAudioVideoPlayed = (isProfileRedesign?: boolean) => {
  HeapService.track(
    isProfileRedesign
      ? HeapCustomEvent.ProfileRedesignAgentAudioVideoPlayed
      : HeapCustomEvent.AgentAudioVideoPlayed
  );
};

const profileEdited = (isProfileRedesign?: boolean) => {
  HeapService.track(
    isProfileRedesign
      ? HeapCustomEvent.ProfileRedesignIsEdited
      : HeapCustomEvent.ProfileIsEdited
  );
};

const checkIsPerformerWithAudioEndpoint = () =>
  checkIsPerformer() && PATH_NAME === AUDIO_ENDPOINT;

const checkIsAgentWithAudioEndpoint = () =>
  checkIsAgent() && PATH_NAME === AUDIO_ENDPOINT;

const checkIsPerformerWithVideoEndpoint = () =>
  checkIsPerformer() && PATH_NAME === VIDEO_ENDPOINT;

const checkIsAgentWithVideoEndpoint = () =>
  checkIsAgent() && PATH_NAME === VIDEO_ENDPOINT;

export const heapTrackingForChangeMainPhotoFlow = (
  isProfileRedesign?: boolean
) => {
  if (checkIsPerformer()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignHeadShotPerformer
        : HeapCustomEvent.HeadShotPerformer
    );
  }

  if (checkIsAgent()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignHeadShotAgent
        : HeapCustomEvent.HeadShotAgent
    );
  }

  profileUpdate(isProfileRedesign);
};

export const heapTrackingForControlsContainer = (
  isProfileRedesign?: boolean
) => {
  if (checkIsPerformerWithAudioEndpoint()) {
    audioClipsPerformerUpdate(isProfileRedesign);
  }

  if (checkIsAgentWithAudioEndpoint()) {
    audioClipsAgentUpdate(isProfileRedesign);
  }

  if (checkIsPerformerWithVideoEndpoint()) {
    videoPerformerUpdate(isProfileRedesign);
  }

  if (checkIsAgentWithVideoEndpoint()) {
    videoAgentUpdate(isProfileRedesign);
  }
};

export const heapTrackingForAddNewAudiPage = (isProfileRedesign?: boolean) => {
  if (checkIsPerformer()) {
    audioClipsPerformerUpdate(isProfileRedesign);
  }

  if (checkIsAgent()) {
    audioClipsAgentUpdate(isProfileRedesign);
  }

  profileUpdate(isProfileRedesign);
};

export const heapTrackingForReorderableList = (isProfileRedesign?: boolean) => {
  heapTrackingForControlsContainer(isProfileRedesign);
};

export const heapTrackingForAddNewVideoPage = (isProfileRedesign?: boolean) => {
  if (checkIsPerformer()) {
    videoPerformerUpdate(isProfileRedesign);
  }

  if (checkIsAgent()) {
    videoAgentUpdate(isProfileRedesign);
  }

  profileUpdate(isProfileRedesign);
};

export const heapTrackingForBasicInfoPage = (isProfileRedesign?: boolean) => {
  if (checkIsPerformer()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignDetailsPerformer
        : HeapCustomEvent.DetailsPerformer
    );
  }

  if (checkIsAgent()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignDetailsAgent
        : HeapCustomEvent.DetailsAgent
    );
  }

  profileUpdate(isProfileRedesign);
};

export const heapTrackingForSkillsPageSkillUpdate = (
  isProfileRedesign?: boolean
) => {
  if (checkIsPerformer()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignSkillsPerformer
        : HeapCustomEvent.SkillsPerformer
    );
  }

  if (checkIsAgent()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignSkillsAgent
        : HeapCustomEvent.SkillsAgent
    );
  }
};

export const heapTrackingForAboutMePage = (isProfileRedesign?: boolean) => {
  if (checkIsPerformer()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignHighlightsPerformer
        : HeapCustomEvent.AboutMePerformer
    );
  }

  if (checkIsAgent()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignHighlightsAgent
        : HeapCustomEvent.AboutMeAgent
    );
  }

  profileUpdate(isProfileRedesign);
};

export const heapTrackingForEditCreditPage = (isProfileRedesign?: boolean) => {
  if (checkIsPerformer()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignCreditsPerformer
        : HeapCustomEvent.CreditsPerformer
    );
  }

  if (checkIsAgent()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignCreditsAgent
        : HeapCustomEvent.CreditsAgent
    );
  }

  profileUpdate(isProfileRedesign);
};

export const heapTrackingForAddAgencyPage = (isProfileRedesign?: boolean) => {
  profileUpdate(isProfileRedesign);
};

export const heapTrackingForAgenciesPage = (isProfileRedesign?: boolean) => {
  profileUpdate(isProfileRedesign);
};

export const heapTrackingForSkillsPageProfileUpdate = (
  isProfileRedesign?: boolean
) => {
  profileUpdate(isProfileRedesign);
};

export const heapTrackingForTrainingPage = (isProfileRedesign?: boolean) => {
  profileUpdate(isProfileRedesign);
};

export const heapTrackingForMediaSection = (isProfileRedesign?: boolean) => {
  if (checkIsCD()) {
    cdAudioVideoPlayed(isProfileRedesign);
  }

  if (checkIsAgent()) {
    agentAudioVideoPlayed(isProfileRedesign);
  }
};

export const heapTrackingForAudioClips = (isProfileRedesign?: boolean) => {
  if (checkIsAgent()) {
    agentAudioVideoPlayed(isProfileRedesign);
  }

  if (checkIsCD()) {
    cdAudioVideoPlayed(isProfileRedesign);
  }
};

export const heapTrackingForShowreels = (isProfileRedesign?: boolean) => {
  heapTrackingForAudioClips(isProfileRedesign);
};

export const heapTrackingForMainPageEmailProfile = (
  isProfileRedesign?: boolean
) => {
  if (checkIsAgent()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignAgentEmailProfile
        : HeapCustomEvent.AgentEmailProfile
    );
  }

  if (checkIsCD()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignCDEmailProfile
        : HeapCustomEvent.CDEmailProfile
    );
  }
};

export const heapTrackingForMainPagePrintProfile = (
  isProfileRedesign?: boolean
) => {
  if (checkIsAgent()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignAgentPrintProfile
        : HeapCustomEvent.AgentPrintProfile
    );
  }

  if (checkIsCD()) {
    HeapService.track(
      isProfileRedesign
        ? HeapCustomEvent.ProfileRedesignCDPrintProfile
        : HeapCustomEvent.CDPrintProfile
    );
  }
};

export function heapTrackingProfileEdit(isProfileRedesign?: boolean) {
  if (checkIsPerformer() || checkIsAgent()) {
    profileEdited(isProfileRedesign);
  }
}

export const heapTrackingForAgenciesSection = () => {
  if (checkIsPerformer() || checkIsAgent()) {
    profileEdited();
  }
};

export const heapTrackingForBasicInfoSection = () => {
  heapTrackingForAgenciesSection();
};

export const heapTrackingForEditPanel = () => {
  heapTrackingForAgenciesSection();
};

export const heapTrackingForRowGallery = () => {
  heapTrackingForAgenciesSection();
};

export const heapTrackingForReorderableMediaAssets = (
  isProfileRedesign?: boolean
) => {
  if (checkIsPerformerWithAudioEndpoint()) {
    audioClipsPerformerUpdate(isProfileRedesign);
  }
};

export const heapTrackingForShowreelsSortCompleted = (
  isProfileRedesign?: boolean
) => {
  if (checkIsPerformerWithVideoEndpoint()) {
    videoPerformerUpdate(isProfileRedesign);
  }
};
